export default __webpack_public_path__ + "assets/images/491a72b371b5e396564ca7439a45124a.mp3";